import { pathJoin } from '../utils'

export const createPageRegisterRoutesMap = (prefix: string) => ({
  'need-more-info': pathJoin(prefix)('need-more-info').chain,
})
